export default [
  {
    seed: 0,
    result: 4,
  },
  {
    seed: 1,
    result: 5,
  },
  {
    seed: 2,
    result: 6,
  },
  {
    seed: 3,
    result: 7,
  },
  {
    seed: 4,
    result: 8,
  },
  {
    seed: 5,
    result: 9,
  },
  {
    seed: 6,
    result: 0,
  },
  {
    seed: 7,
    result: 1,
  },
  {
    seed: 8,
    result: 0,
  },
  {
    seed: 9,
    result: 1,
  },
  {
    seed: 10,
    result: 2,
  },
  {
    seed: 11,
    result: 3,
  },
];
